import { getConfig } from '../../appConfig.js';

export const getNavigationItems = (__) => {
  const config = getConfig();
  const data = config?.bottomNavigationData || [];
  if (data.length > 0) {
    return data.map((el) => ({
      url: el.url,
      params: el.tab ? { tab: el.tab } : null,
      text: __(el.text),
      icon: <img src={el.icon} alt="" />,
      iconActive: el.icon_active ? <img src={el.icon_active} alt="" /> : null,
    }));
  }
  const { flags } = config;
  return [
    {
      url: '/dashboard',
      params: null,
      text: __('Home'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="1.5" className="icon icon-tabler icons-tabler-outline icon-tabler-home">
          <path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
          <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
        </svg>
      ),
    },
    {
      url: '/history',
      params: { tab: 'order' },
      text: flags.hasOrdering ? __('Orders') : __('History'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-basket" viewBox="0 0 24 24" strokeWidth="1.5" fill="none">
          <polyline points="7 10 12 4 17 10" />
          <path d="M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z" />
          <circle cx="12" cy="15" r="2" />
        </svg>
      ),
    },
    ...(flags.hasLoyalty
      ? [
          {
            url: '/loyalty',
            params: null,
            text: __('Loyalty'),
            icon: (
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-star" viewBox="0 0 24 24" strokeWidth="1.5" fill="none">
                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
              </svg>
            ),
          },
        ]
      : []),
    {
      url: '/account',
      params: null,
      text: __('My account'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-settings" viewBox="0 0 24 24" strokeWidth="1.5" fill="none">
          <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ),
    },
  ];
};
